import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../Common/TextFieldInput'
import ButtonInput from '../Common/ButtonInput'
import Loader from '../Common/Loader'
import {PropyLogoIcon} from '../Common/Icons/Icons'
import {withRouter} from 'react-router';
import './PasswordRecovery.scss';

class PasswordRecovery extends Component {

    state = {
        email: '',
        sentEmail: false,
        isLoading: false
    };

    render() {
        const {email, sentEmail, isLoading} = this.state;

        return (
            <div className="password-popup">
                {isLoading && <Loader/>}
                <form className='password-popup__form'>
                    <div className={'form-wrapper'}>
                        <header className="password-popup__header">
                            <h2 className="password-popup__title">Password Recovery</h2>
                        </header>
                        {sentEmail ?
                            <div className="password-popup__body">
                                <div className="fields-row m-b-30 text-link-password m-0-auto">
                                    We've sent you an email with a link to reset your password.
                                </div>
                                <div className="fields-row p-t-30">
                                    <ButtonInput className='dark-button blue-button width-168 m-r-auto m-0-auto '
                                                 title='Ok'
                                                 handleClick={() => this.props.history.push('/')}/>
                                </div>
                            </div>
                            :
                            <div className="password-popup__body">
                                <div className="fields-row m-b-30">
                                    <TextFieldInput name='email'
                                                    label='Email Address'
                                                    value={email}
                                                    required={true}
                                                    classes='width-400'
                                                    handleChange={(e) => this.handleChange(e)}/>
                                </div>
                                <div className="fields-row">
                                    <ButtonInput className='dark-button blue-button width-400'
                                                 title='Reset Password'
                                                 disabled={email.length < 4}
                                                 handleClick={(e) => this.onSubmit(e)}/>
                                </div>
                                <div className="fields-row">
                            <span onClick={() => this.props.history.push('/')}
                                  className='password-link'>← Back to login page</span>
                                </div>
                            </div>}
                    </div>
                </form>
            </div>
        )
    }

    handleChange = event => {
        console.log(event.target.name, event.target.value, 'handle change')
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.formValidate()) {
            this.setState({isLoading: true});
            Api.get(`user/reset_password?email=${this.state.email}`).then((response) => {
                this.setState({isLoading: false});
                if (response.data.status !== '409') {
                    this.setState({email: '', sentEmail: true})
                }
            }).catch((error) => {
                alert(error.response.data)
                this.setState({isLoading: false});
            })
        }
    };

    formValidate = () => {
        const {username, password} = this.state;
        let isValid = true;

        return isValid;
    }
}

export default withRouter(PasswordRecovery);


// WEBPACK FOOTER //
// ./src/components/PasswordRecovery/PasswordRecovery.js